import React from 'react'
import 'app/sm/progress_application/components/header_lg/style.scss'

const AddressHeader = ({ titleClass = '', title = '' }) => {
  return <div className={`title ${titleClass}`}>{title}</div>
}

export default AddressHeader
